import {
  Component,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  ɵɵNgOnChangesFeature,
} from "@angular/core";
import { validate } from "class-validator";
import { EventEmitter } from "events";
import { InvestmentCosting } from "shared/models/investmentcosting";
import * as _ from "underscore";
import { CostingPageService } from "../costing-page.service";
import { InvestmentCostingService } from "./investment-costing.service";

//child component
@Component({
  selector: "app-investment-costing",
  templateUrl: "./investment-costing.component.html",
  styleUrls: ["./investment-costing.component.scss"],
})
export class InvestmentCostingComponent implements OnInit {
  investmentCosting: InvestmentCosting[];
  invest_Data: any = [];
  refData: any;
  in_Data: any[];
  quantity: any;
  amount: any;
  price: any;
  BE_quantity: any;
  BE_price: any;
  BE_Total: any;
  rld_Price: any;
  rld_Amount: any;
  rld_quantity: any;
  df_total: any;
  df_quantity: any;
  df_price: any;
  ip_total: any;
  ip_quantity: any;
  ip_price: any;
  grant_total = [];
  sumOfAmount = 0;
  apiCostFetched: boolean;
  timelineFetched: boolean;
  rldCostFetched: boolean;
  beCostFetched: boolean;
  dfCostFetched: boolean;
  ipCostFetched: boolean;
  regulatoryCostFetched: boolean;
  allCostLoadInterval: any;
  rldCostData: any = {};
  newCost: any = {};
  timeline: any = {};
  newTimeline: any;
  timelineRoa: string;
  timelineBE: any;
  timeline_Oral: any;
  timeline_Milestone: any;
  tableData1: any = [];
  tableData2: any = [];
  editRowID: any = [];
  currentVal = "";
  show = false;
  showPrice = false;
  posVal: any;
  brand_name: any;
  timelineBEStudy11: boolean;
  timelineBEStudy12: boolean;
  timelineBEStudy13: boolean;
  timelineBEStudy14: boolean;
  timelineBEStudy21: boolean;
  timelineBEStudy22: boolean;
  timelineBEStudy23: boolean;
  timelineBEStudy24: boolean;

  /* Consuming data from parent [costing-page] component */
  @Input() MolData: any;
  @Input() needRefresh = false; // passing needRefresh from Parent [Costing component]
  showBE = false;
  showBEPrice = false;
  showDevPrice = false;
  showDevCost = false;
  showIP = false;
  showIPPrice = false;
  disable = false;
  activiIngredient: any;
  percent: any;
  showPricePer = false;
  totalNumber = false;
  total_Amount = 0;
  combination_quantity: any;
  combination_price: any;
  tempMapping: any = [];
  combination_rld_Price: any;
  email: any;

  constructor(
    private investmentService: InvestmentCostingService,
    private service: CostingPageService
  ) {
    // creating data to 2nd table

    this.tableData1 = [
      {
        id: 1,
        name: "Normal BE studies",
        data1: "20",
        data2: "20",
        data3: "37",
        data4: "40",
      },
      // {id: 2, name: 'PK end point / Patient BE', data1: '32', data2: '28', data3: '37', data4: '40'}
    ];

    this.tableData2 = [
      // {id: 1, name: 'Normal BE studies', data1: '20' , data2: '20', data3: '37', data4: '40'}
      {
        id: 2,
        name: "PK end point / Patient BE",
        data1: "32",
        data2: "28",
        data3: "37",
        data4: "40",
      },
    ];
  }

  edit(val) {
    this.editRowID = val;
    console.log("editROWID", val);
  }

  ngOnInit() {
    this.email = localStorage.getItem("email");
    this.investmentService.getInvestmentCostDetails().subscribe((res: any) => {
      this.invest_Data = res.Investment_Cost as InvestmentCosting;
    });
  }

  /**
   *
   * @param changes To keep track of needRefresh option from child component based on api response
   */
  ngOnChanges(changes: SimpleChanges) {
    // changes.prop contains the old and the new value...
    // changes.
    for (let property in changes) {
      if (
        property == "needRefresh" &&
        changes["needRefresh"].currentValue == true
      ) {
        this.grant_total = [];
        this.postAPICostDetails();
        this.regulatoryDetails();
        this.postBE_StudyDetails();
        this.postRLD_StudyDetails();
        this.postdfComplexity_cost_StudyDetails();
        this.postIp_cost_StudyDetails();
        this.getTimelineDetails();
        this.cumulativeInvestment();
        this.grandTotalCalculation();
        // this.getProjectKickOff();
        // this.getProtoTypeDev();
        // this.getpivotal_BE();
        // this.getExhibitBatches();
        // this.getICHStability() ;
        // this.getNewCosting();
      }
    }
  }

  onClick() {
    this.show = !this.show;
    this.showPrice = !this.showPrice;
    this.showBE = !this.showBE;
    this.showBEPrice = !this.showBEPrice;
    this.showDevCost = !this.showDevCost;
    this.showDevPrice = !this.showDevPrice;
    this.showIP = !this.showIP;
    this.showIPPrice = !this.showIPPrice;
    this.showPricePer = !this.showPricePer;
    this.totalNumber = !this.totalNumber;
    this.disable = !this.disable;
  }

  getVal(val) {
    this.currentVal = val;
    let curVal = this.currentVal;
    console.log("CURRENT VAL", curVal);
  }

  /**
   * Method to display  regulatory Details
   */
  regulatoryDetails() {
    let referdata: any = localStorage.getItem("molecules");
    let moleculedata: any = JSON.parse(referdata);

    // const MData = this.MolData.split(",");
    // console.log("MolData", MData);
    // let moleculeData: any = {
    //   nda_number: MData[1],
    //   brand_name: MData[0],
    // };
    const MData = this.MolData;
    console.log("MolData", MData);
    let moleculeData = {
      brand_name: MData.brand_name,
      nda_number: MData.nda_number,
      user_email: this.email
    };
    console.log("moleculedata", moleculeData)
    this.investmentService
      .getRegulatoryCost(moleculeData)
      .subscribe((regulatory) => {
        this.refData = regulatory;
        this.in_Data = this.refData.data.regulatory_curr_cost;
        setTimeout(() => {
          this.grant_total.push(this.in_Data);
        }, 2000);
      });
  }

  /**
   * Method to display  API CostDetails
   */
  postAPICostDetails() {
    this.quantity = "";
    this.price = "";
    this.amount = "";
    console.log("MolData", this.MolData);
    let referdata: any = localStorage.getItem("molecules");
    let moleculedata: any = JSON.parse(referdata);

    const MData = this.MolData;
    console.log("MolData", MData);
    if (!this.email) {
      this.email = localStorage.getItem("email");
    }
    console.log("Email in postAPICostDetails", this.email);

    let moleculeData = {
      brand_name_proprietary_name: MData.brand_name,
      nda_number: MData.nda_number,
      user_email: this.email
    };
    console.log("moleculedata-cosetdetails", moleculeData)
    this.investmentService
      .displayAPICost(moleculeData)
      .subscribe((resp: any) => {
        console.log("API Cost", resp);
        if (Array.isArray(moleculedata["Active Ingredient"]) === false) {
          (this.quantity = resp.data.api_kg_total),
            (this.price = resp.data.price);
        } else {
          (this.combination_quantity = resp.data.api_kg_total),
            (this.combination_price = resp.data.price);
        }

        this.amount = resp.data.amount;
        setTimeout(() => {
          this.grant_total.push(this.amount);
        }, 2000);
      });
  }

  /**
   * Method to display TIMELINE
   */

  getTimelineDetails() {
    this.newTimeline = "";
    this.timelineBEStudy11 = true;
    this.timelineBEStudy12 = true;
    this.timelineBEStudy13 = true;
    this.timelineBEStudy14 = true;
    this.timelineBEStudy21 = true;
    this.timelineBEStudy22 = true;
    this.timelineBEStudy23 = true;
    this.timelineBEStudy24 = true;

    let OData1 = 20;
    let OralData1 = parseInt(this.currentVal);
    let newBEValue = 0;
    if (OralData1 > 0) {
      newBEValue = OralData1;
    } else {
      newBEValue = OData1;
    }

    // const TData = this.MolData.split(",");
    // let moleculeData: any = {
    //   brand_name_proprietary_name: TData[0],
    //   nda_number: TData[1],
    //   be_study: newBEValue,
    // };
    const TData = this.MolData;
    console.log("MolData", TData);
    let moleculeData = {
      brand_name_proprietary_name: TData.brand_name,
      nda_number: TData.nda_number,
      be_study: newBEValue,
      user_email: this.email,
    };
    console.log("moleculedata-timeline", moleculeData)
    this.brand_name = TData.brand_name;
    this.investmentService
      .getTimeline(moleculeData)
      .subscribe((timeline: any) => {
        //  this.timeline = timeline;
        this.newTimeline = timeline[0];
        this.timelineRoa = timeline[1];
        this.timelineBE = timeline[2];

        if (this.timelineRoa == "ORAL" && this.timelineBE == "no") {
          this.timelineBEStudy11 = false;
          // OData1 = parseInt(this.tableData1[0].data1);
        } else if (this.timelineRoa == "ORAL" && this.timelineBE == "yes") {
          this.timelineBEStudy21 = false;
          // OData1 = parseInt(this.tableData2[0].data1);
        } else if (
          this.timelineRoa == "Injectable" &&
          this.timelineBE == "no"
        ) {
          this.timelineBEStudy12 = false;
          // OData1 = parseInt(this.tableData1[0].data2);
        } else if (
          this.timelineRoa == "Injectable" &&
          this.timelineBE == "yes"
        ) {
          this.timelineBEStudy22 = false;
          // OData1 = parseInt(this.tableData2[0].data2);
        } else if (this.timelineRoa == "Topical" && this.timelineBE == "no") {
          this.timelineBEStudy13 = false;
          // OData1 = parseInt(this.tableData1[0].data3);
        } else if (this.timelineRoa == "Topical" && this.timelineBE == "yes") {
          this.timelineBEStudy23 = false;
          // OData1 = parseInt(this.tableData2[0].data3);
        } else if (this.timelineRoa == "Others" && this.timelineBE == "no") {
          this.timelineBEStudy14 = false;
          // OData1 = parseInt(this.tableData1[0].data4);
        } else if (this.timelineRoa == "Others" && this.timelineBE == "yes") {
          this.timelineBEStudy24 = false;
          // OData1 = parseInt(this.tableData2[0].data4);
        }
      });
  }

  /**
   * Method to display BE_StudyDetails
   */
  postBE_StudyDetails() {
    this.BE_Total = "";
    // const studyData = this.MolData.split(",");
    // let moleculeData: any = {
    //   brand_name_proprietary_name: studyData[0],
    //   nda_number: studyData[1],
    // };
    const studyData = this.MolData;
    console.log("MolData", studyData);
    let moleculeData = {
      brand_name_proprietary_name: studyData.brand_name,
      nda_number: studyData.nda_number,
      user_email: this.email,
    };

    this.investmentService
      .displayBEStudy(moleculeData)
      .subscribe((study: any) => {
        this.BE_quantity = "1";
        this.BE_price = study.data.grand_total;
        this.BE_Total = study.data.grand_total;
        setTimeout(() => {
          this.grant_total.push(this.BE_Total);
        }, 2000);
      });
  }

  /**
   * Method to display DF Complexity Cost
   */

  postdfComplexity_cost_StudyDetails() {
    this.df_price = "";
    this.df_quantity = "";
    this.df_total = "";
    // const studyData = this.MolData.split(",");
    // // console.log('studyData',studyData)
    // let moleculeData: any = {
    //   brand_name_proprietary_name: studyData[0],
    //   nda_number: studyData[1],
    // };
    const studyData = this.MolData;
    console.log("MolData", studyData);
    let moleculeData = {
      brand_name_proprietary_name: studyData.brand_name,
      nda_number: studyData.nda_number,
      user_email: this.email,
    };

    this.investmentService
      .getAnalyticalCost(moleculeData)
      .subscribe((study: any) => {
        console.log("development cost response", study);
        this.df_total = study.data.total_cost;
        this.df_price = study.data.price;
        this.df_quantity = study.data.quantity;
        setTimeout(() => {
          this.grant_total.push(this.df_total);
        }, 2000);
      });
  }

  /**
   * Method to display IP  Cost
   */
  postIp_cost_StudyDetails() {
    this.ip_price = "";
    this.ip_quantity = "";
    this.ip_total = "";
    const studyData = this.MolData;
    console.log("MolData", studyData);
    let moleculeData = {
      brand_name_proprietary_name: studyData.brand_name,
      nda_number: studyData.nda_number,
      user_email: this.email,
    };

    this.investmentService.getIpCost(moleculeData).subscribe((study: any) => {
      this.ip_total = study.data.total;
      this.ip_price = study.data.price;
      this.ip_quantity = study.data.quantity;
      setTimeout(() => {
        this.grant_total.push(this.ip_total);
      }, 2000);
    });
  }

  /**
   * Method to display RLD Complexity Cost
   */

  postRLD_StudyDetails() {
    this.rldCostData = "";
    this.rld_Amount = "";
    const studyData = this.MolData;
    console.log("MolData-RLD study", studyData);
    let moleculeData = {
      brand_name_proprietary_name: studyData.brand_name,
      nda_number: studyData.nda_number,
      user_email: this.email,
    };

    this.investmentService
      .rldStudyCost(moleculeData)
      .subscribe((rldstudy: any) => {
        this.rldCostData = rldstudy.data;
        if (Array.isArray(rldstudy.data.RLD_Price) === false) {
          this.rld_Price = rldstudy.data.RLD_Price;
        } else {
          this.combination_rld_Price = rldstudy.data.RLD_Price;
        }
        this.rld_quantity = rldstudy.data.quantity;
        this.rld_Amount = rldstudy.data.Amount;
        setTimeout(() => {
          this.grant_total.push(this.rld_Amount);
        }, 2000);
      });
  }

  cumulativeInvestment() {
    const studyData = this.MolData;
    console.log("MolData", studyData);
    let moleculeData = {
      brand_name: studyData.brand_name,
      nda_number: studyData.nda_number,
      user_email: this.email,
    };

    this.investmentService
      .getCumulativeInvestment(moleculeData)
      .subscribe((res: any) => { });
  }
  /**
   * Method to calculate total grant amount
   * @returns sum of Amount grant total amount
   */

  grandTotalCalculation() {
    this.sumOfAmount = 0;
    let value = 0;
    if (this.grant_total.length > 0) {
      this.grant_total.map((element) => {
        let temp = element.toString().replace(/[^0-9.]/g, "");
        value = +temp;
        this.sumOfAmount = this.sumOfAmount + value;
      });
    }
    return this.sumOfAmount;
  }

  editAPICostDetails() {
    for (let i = 0; i < this.rld_quantity.length; i++) {
      let temp = this.rld_quantity[i].Total_no_of_packs_required;
      let temp2 = this.rld_quantity[i].Price_per_pack;
      let temp_dict = {
        total_no_of_packs_required: temp,
        price_per_pack: temp2,
      };
      this.tempMapping.push(temp_dict);
    }
    const MData = this.MolData.split(",");
    let moleculeData: any = {
      data: {
        nda: MData[1],
        brand_name: MData[0],
        user_email: this.email,
        edited_apicost_quantity: this.quantity,
        edited_apicost_price: this.price,
        edited_ipcost_quantity: this.ip_quantity,
        edited_ipcost_price: this.ip_price,
        edited_bestudycost_quantity: this.BE_quantity,
        edited_bestudycost_price: this.BE_price,
        edited_devcost_quantity: this.df_quantity,
        edited_devcost_price: this.df_price,
        edited_rld_quantity: this.tempMapping,
      },
    };
    this.investmentService.editAPICost(moleculeData).subscribe((resp: any) => {
      console.log("RESPSSS", resp);
      this.amount = resp.data.api_cost.final_amount;
      this.rld_Price = resp.data.rld_cost.rld_prices;
      this.rld_Amount = resp.data.rld_cost.final_amount;
      this.BE_Total = resp.data.bestudy_cost.final_amount;
      this.df_total = resp.data.dev_cost.final_amount;
      this.ip_total = resp.data.ip_cost.final_amount;
      this.total_Amount =
        resp.data.sum_of_apicost_ipcost_bestudycost_devcost_rldcost;
      this.onClick();
    });
  }
}
